<template>
  <modal parent-name="TFAModal" v-bind="$props" @close="closeModal">
    <template v-slot:title>
      {{ $tc("otp") }}
    </template>
    <template v-slot:text>
      <template>
        <v-alert class="my-4" color="warning" icon="warning">
          {{ $tc("otp_created") }}
        </v-alert>
        <v-row align="center" justify="center" class="h-55v">
          <v-col align-self="center" cols="9">
            <v-otp-input length="6" v-model="tfa" type="number" />
              <v-btn
                  dark
                  block
                  id="TFA_submit"
                  type="submit"
                  :loading="loading"
                  @click="submit"
              >
                  {{ $tc("validate_code") }}
              </v-btn>
          </v-col>
        </v-row>
      </template>
    </template>
  </modal>
</template>

<script>
import { Modal } from "@dinamonetworks/gui-comps-lib";
export default {
  components: { Modal },
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      tfa: "",
      loading: false,
    };
  },
  methods: {
    submit() {
      if (!this.tfa || this.tfa.length !== 6)
        this.$notify.error({
          message: this.$t("$validation.exact_length", { num: 6 }),
        });
      else {
        this.loading = true;
        this.$store
          .dispatch("tfa/doCheckTFA", { body: { value: this.tfa } })
          .then(({ token, refresh_token }) => {
            this.$store.commit("auth/SET_STATE", {
              token,
              refresh_token,
              isLogged: true,
            });
            this.$router.push({ name: "home" });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
     closeModal() {
      this.tfa = null;
      this.$emit("close");
    },
  },
};
</script>